export const yodaBudgetConstants = {
  GETBUDGET_REQUEST: "YODABUDGET_GETBUDGET_REQUEST",
  GETBUDGET_SUCCESS: "YODABUDGET_GETBUDGET_SUCCESS",
  GETBUDGET_FAILURE: "YODABUDGET_GETBUDGET_FAILURE",
};
